import { render, staticRenderFns } from "./LabelsReports.vue?vue&type=template&id=7af09252&scoped=true&"
import script from "./LabelsReports.vue?vue&type=script&lang=js&"
export * from "./LabelsReports.vue?vue&type=script&lang=js&"
import style0 from "./LabelsReports.vue?vue&type=style&index=0&id=7af09252&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af09252",
  null
  
)

export default component.exports